import {
  fetchTransactionsFiltered,
  getBodyPayloadFiltered,
} from 'components/Transactions/func';
import { checkMaintenance } from 'helpers/maintenance';
import { searchTextValid } from 'helpers';
import useAuth from 'hooks/useAuth';
import useDetectEndpointVisibleOnScreen from 'hooks/useDetectEndpointVisibleOnScreen';
import useThrottle from 'hooks/useThrottle';
import { useEffect } from 'react';

const PaginationMobile = ({
  applyFiltered,
  searchValue,
  currentSearchBy,
  currentPage,
  totalPages,
  setCurrentPage,
  transactions,
  setTransactions,
  isSearched,
}) => {
  const { token } = useAuth();
  const { throttle } = useThrottle(1);
  const isIntersecting = useDetectEndpointVisibleOnScreen();

  const fetchTransactionsPagination = (page) => {
    throttle(() => {
      if (!searchTextValid(searchValue)) return;

      try {
        let bodyPayload = getBodyPayloadFiltered(applyFiltered);

        bodyPayload = {
          ...bodyPayload,
          [currentSearchBy]: isSearched ? searchValue : '',
        };

        fetchTransactionsFiltered({
          token,
          body: bodyPayload,
          page,
          transactions,
          setTransactions,
          setCurrentPage,
        });
      } catch (error) {
        checkMaintenance(error);
        console.error(error?.message);
      }
    });
  };
  const handleNextPage = (page) => {
    if (totalPages === currentPage) return;
    fetchTransactionsPagination(page);
  };

  useEffect(() => {
    if (isIntersecting) {
      handleNextPage(currentPage + 1);
    }
  }, [isIntersecting, currentPage]);

  return null;
};

export default PaginationMobile;
